import TRAINING_CATEGORIES from "./_trainingCategories";
import { createTranslator } from "../../utils/translate";
import de from "./de.json";
import en from "./en.json";

const translations = { de, en };

export const FORMAT_OPTIONS = [{ key: "online" }, { key: "presence" }];

export const getFormatLabel = (key, language = "de") => {
  const t = createTranslator(language, translations);
  const map = { online: t("formatOnline"), presence: t("formatPresence") };
  return map[key] || "—";
};

export const getCategoryLabel = (key, language = "de") => {
  const cat = TRAINING_CATEGORIES.find((c) => c.key === key);
  if (!cat) return key;
  return typeof cat.label === "object"
    ? cat.label[language] || cat.label.de
    : cat.label;
};

export const toggle = (list, key) =>
  list.includes(key) ? list.filter((k) => k !== key) : [...list, key];

export const isExpiredCourse = (course) => {
  const endDate = course.get("endDate");
  return !!(endDate && endDate < new Date());
};
